import { ApiBase } from "./ApiBase";
import { Language, Map, FieldTranslation } from "typings";

export class TranslationAPI extends ApiBase
{
    async getLanguages(): Promise<Language[]>
    {
        const response = await this.fetch("translation");
        return response.json();
    }

    async newLanguage(language: string): Promise<Language[]>
    {
        const response = await this.fetch(`translation/${language}`, {
            method: "PUT"
        });
        return response.json();
    }

    async getTranslation(language: string): Promise<Map<string>>
    {
        const response = await this.fetch(`translation/${language}`);
        return response.json();
    }

    async removeField(fieldName: string): Promise<void>
    {
       await this.fetch(`translation/removeField/${fieldName}`, 
        {
            method: "DELETE"
        });
    }

    async createField(fieldName: string): Promise<void>
    {
        await this.fetch(`translation/newField?fieldName=${fieldName}`, 
        {
            method: "PUT"
        });
    }

    async updateField(language: string, fieldName: string, value: string): Promise<void>
    {
        await this.fetch(`translation/${language}/${fieldName}/${value}`, 
        {
            method: "PUT"
        });
    }

    async getAllLanguages(): Promise<Language[]>
    {
        const response = await this.fetch(`translation/allLanguages`);

        return response.json();
    }

    async getFieldTranslations(language: string): Promise<FieldTranslation[]>
    {
        return await this.get(`frontend/field/all/${language}`);
    }

    async searchField(property: string, language: string, term: string): Promise<string[]>
    {
        return await this.get(`frontend/field/${property}/${language}/${term}`);
    }

}


// WEBPACK FOOTER //
// ./src/services/translation.ts